/**
 * Checking if the list contains changes
 * @param oldData - The list of the previous data
 * @param newData - The list of the new data
 */
export const responseHasChanges = <T extends unknown>(oldData: any[], newData: any[]): boolean => {
	if (Array.isArray(newData) || Array.isArray(oldData)) {
		if (oldData.length !== newData.length) {
			return true;
		}
		if (!oldData?.length || !newData?.length) {
			return !(oldData?.length === newData?.length);
		}
		const hasId = oldData[0].id && newData[0].id;
		if (hasId) {
			oldData.sort((a, b) => a.id - b.id);
			newData.sort((a, b) => a.id - b.id);
		}
	}
	return JSON.stringify(oldData) !== JSON.stringify(newData);
};